import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shanchu",
  "use": "icon-shanchu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shanchu\"><defs><style type=\"text/css\"></style></defs><path d=\"M929.375 482H94.625c-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30h834.75c16.568 0 30-13.431 30-30 0-16.568-13.432-30-30-30z\" p-id=\"3858\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol